import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-10" }
const _hoisted_2 = { class: "fw-bold my-2 text-fprimary" }
const _hoisted_3 = { class: "ms-4 badge rounded-pill bg-fprimary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_5 = {
  key: 0,
  class: "row g-6 g-xl-9 mb-6 mb-xl-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTFile = _resolveComponent("KTFile")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.t("documentAsociated")) + " ", 1),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.listDocs.length) + " ", 1),
          _hoisted_4
        ])
      ])
    ]),
    (_ctx.listDocs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDocs, (item, index) => {
            return (_openBlock(), _createBlock(_component_KTFile, {
              key: `itmf-${index}`,
              "file-title": item.nombre,
              "file-type": "pdf",
              "created-at": "3 days ago",
              file: item.ruta
            }, null, 8, ["file-title", "file"]))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ])
  ], 64))
}